import React, { useRef, useState, useEffect, useLayoutEffect } from "react"
import '../landing.css';
import {  Link, useHistory} from "react-router-dom";

import { firestore } from "../firebase/firebase";

import SignInModal from '../signin';
import SignUpModal from '../signup';

import PlansButton from "../paymentLanding";

import { AppBar, Toolbar, Button, Divider, IconButton, AccordionDetails, Typography, Grid, CardMedia, Card, CardContent, Box} from "@mui/material";

import { makeStyles } from '@material-ui/core/styles';
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import TextField from "@material-ui/core/TextField";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import cloud from "../cloud.svg"
import logo from "../logo.png"
import { Avatar } from '@material-ui/core';

import imageOne from "../imageOne.svg"
import imageTwo from "../imageTwo.svg"

import Crowd from "../../components/Crowd.mp4"

import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

import { useAuth } from "../firebase/AuthContext";

import Password from "../forgotPassword";

import talk from "./images/6/talk.gif"
import dis from "./images/6/dis.gif"
import fast from "./images/6/fast.gif"
import thinking from "./images/6/think.gif"
import smart from "./images/6/smart.gif"
import peace from "./images/6/peace.gif"


const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rounded: {
    borderRadius: "10px",
    border: "none",
  },
  container: {
    backgroundColor: "#F9FAFB",
    padding: "8%",
  },
  image: {
    width: "100%",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
  },
  title: {
    fontFamily: "Inter",
    fontSize: "35px",
    fontWeight: "bold",
  },
  subtitle: {
    fontFamily: "Inter",
    color: "#6B7280",
    fontSize: "18px",
  },
  
}));


const posts = [{
  id: 1,
  title: 'What does dyslexia do to a person?',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a common learning disability that affects reading and writing abilities. Individuals with dyslexia often struggle with phonological processing, which makes it difficult to connect sounds and letters together. However, dyslexia can also have additional effects beyond reading and writing difficulties, such as trouble with word retrieval, following directions, and organizing thoughts. In particular, individuals with dyslexia may have difficulty communicating and explaining their ideas. In this blog post, we will explore the different types of dyslexia, common symptoms, causes, and treatments. We will also discuss how dyslexia can impact communication and provide strategies for coping and developing strong communication skills.',
  url: '/What-does-dyslexia-do-to-a-person'
},
{
  id: 2,
  title: 'How does dyslexia affect thinking?',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a common learning disability that affects millions of people worldwide. It is a complex disorder that can affect various aspects of learning, including reading, writing, and math. Dyslexia can also impact an individuals social and emotional well-being, making it crucial to understand how it affects thinking. In this article, we will explore the cognitive, reading, writing, and math difficulties associated with dyslexia, and how they impact learning and everyday life. We will also discuss the importance of early detection and evidence-based interventions for managing dyslexia. By the end of this guide, you will have a better understanding of how dyslexia affects thinking and the strategies for overcoming its challenges.',
  url: '/How-does-dyslexia-affect-thinking'
},
{
  id: 3,
  title: 'The Benefits of Dyslexia: Why its time to change the narrative',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is often portrayed as a learning disability or a hindrance, but what if we told you that it is actually an advantage? That iss right, dyslexia comes with many benefits that are often overlooked due to the negative stigma surrounding it.',
  url: '/Benefits-of-dyslexia'
},
{
  id: 4,
  title: 'How Does Dyslexia Affect Communication? Understanding the Impact of Dyslexia on Communication Skills',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a common learning disorder that affects language processing and comprehension. It is estimated that up to 15% of the population may have dyslexia, with varying degrees of severity. While dyslexia is most commonly associated with difficulties in reading and writing, it can also have a significant impact on communication skills.',
  url: '/How-does-dyslexia-affect-communication'
},
{
  id: 5,
  title: 'What is a Thinking Framework?',
  datePublished: '17/03/2023',
  summary: 'Every day, we face a multitude of decisions, both big and small, that can have a significant impact on our lives. From choosing what to eat for breakfast to deciding on a career path, the choices we make can shape our future in profound ways. However, making the right decision is not always easy, and can often be overwhelming, especially when dealing with complex issues. This is where a thinking framework comes in.',
  url: '/What-is-a-thinking-framework'
},
{
  id: 6,
  title: 'Does dyslexia affect verbal comprehension?',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a common learning disorder that affects the ability to read, write, and spell. People with dyslexia may struggle with phonemic awareness, decoding, and word recognition, which can impact their academic performance and everyday life. However, dyslexia is not just limited to reading and writing; it can also affect other areas of learning, such as verbal comprehension. Verbal comprehension is the ability to understand and process spoken language, which is crucial for communication, learning, and social interactions. In this blog post, we will explore the relationship between dyslexia and verbal comprehension. We will examine the challenges that people with dyslexia face in understanding spoken language and discuss strategies to improve their verbal comprehension skills. Understanding this relationship can help educators, parents, and individuals with dyslexia to better navigate and overcome the challenges associated with dyslexia.',
  url: '/Does-dyslexia-affect-verbal-comprehension'
},
{
  id: 7,
  title: 'Understanding Communication Challenges for Neurodivergent Individuals',
  datePublished: '17/03/2023',
  summary: 'Neurodiversity refers to the range of differences in brain function and behavior that exist among individuals. This concept recognizes that neurological differences are a natural part of human variation, and that individuals with conditions such as autism, ADHD, dyslexia, Tourette syndrome, schizophrenia, and bipolar disorder have unique strengths and challenges that should be acknowledged and celebrated. One of the most significant challenges faced by neurodivergent individuals is communication.',
  url: '/Understanding-communication-challenges-for-neurodivergent-individuals'
},
{
  id: 8,
  title: 'Navigating Relationships as a Neurodivergent Individual',
  datePublished: '17/03/2023',
  summary: 'Neurodivergent individuals, including those with autism, ADHD, and other neurological conditions, often face unique challenges when it comes to relationships. Navigating social cues, communication, and emotional regulation can be particularly difficult for these individuals, which can put a strain on their romantic, platonic, and familial relationships. However, understanding how neurodivergence affects relationships and developing strategies to navigate these challenges can help foster stronger connections between neurodivergent individuals and their loved ones. In this blog, we will explore the challenges faced by neurodivergent individuals in relationships and discuss strategies for navigating those challenges. We will also highlight the unique strengths and perspectives that neurodivergent individuals bring to relationships, and why it is important to embrace neurodiversity in all types of relationships.',
  url: '/Navigating-relationships-as-a-neurodivergent-individual'
},
{
  id: 9,
  title: 'Exploring the Connection between Dyslexia and Difficulty with Explanation',
  datePublished: '17/03/2023',
  summary: 'In this blog post, we explore the connection between dyslexia and difficulty with explanation. We delve into the causes and common signs of dyslexia, the impact it has on communication, and strategies to help dyslexic people explain effectively.',
  url: '/Exploring-the-Connection-between-Dyslexia-and-Difficulty-with-Explanation'
},
{
  id: 10,
  title: 'How to Develop an Effective Communication Strategy in Your Personal Life',
  datePublished: '17/03/2023',
  summary: 'Effective communication is a crucial element in our personal lives. Our ability to communicate effectively can impact our relationships, career, and overall well-being. Communication strategies can help individuals achieve their personal goals and maintain healthy relationships with others. In this article, we will explore what communication strategies are and why they are important in personal life. We will also discuss steps to develop an effective communication strategy and best practices to improve our communication skills. By the end of this article, you will have a better understanding of how to implement an effective communication strategy in your personal life.',
  url: '/How-to-Develop-an-Effective-Communication-Strategy-in-Your-Personal-Life'
},
{
  id: 11,
  title: 'Why Framework Thinking is Crucial for Success in Today’s World',
  datePublished: '17/03/2023',
  summary: 'In today’s fast-paced and complex world, having a strategic mindset and framework thinking is more important than ever. Framework thinking can help you make better decisions, solve problems, and achieve your goals more efficiently. In this blog post, we will discuss the importance of framework thinking and how it can benefit you.',
  url: '/Why-Framework-Thinking-is-Crucial-for-Success-in-Today’s-World'
},
{
  id: 12,
  title: 'Understanding Mental Frameworks: What They Are and Why They Matter',
  datePublished: '17/03/2023',
  summary: 'Providing a comprehensive overview of mental frameworks, their types, importance, and ways to identify and challenge them. Mental frameworks refer to the beliefs, biases, and assumptions that shape our thoughts, behaviors, and decision-making processes. The article explains various types of mental frameworks, including cultural, personal, and professional, and how they are formed and evolve. The blog highlights the significance of mental frameworks in personal and professional lives and their impact on societal issues such as diversity and inclusion. The article also provides strategies to identify and challenge mental frameworks, broaden perspectives, and enhance creativity and problem-solving skills. The blog concludes by encouraging readers to reflect on their mental frameworks and take steps to expand their perspectives for personal growth and development.',
  url: '/Understanding-Mental-Frameworks-What-They-Are-and-Why-They-Matter'
},
{
  id: 13,
  title: 'Unlocking the Positive Side of Dyslexia: Why People Say Dyslexia is a Gift',
  datePublished: '17/03/2023',
  summary: 'The post will discuss the positive aspects of dyslexia, challenges that people with dyslexia face, scientific explanations for dyslexia, and examples of successful individuals with dyslexia. The post will begin with an introduction that defines dyslexia and addresses negative stereotypes. It will then explore the benefits of dyslexia in different fields, followed by a scientific explanation for why dyslexia can be considered a gift. The post will also discuss the challenges that come with dyslexia and provide strategies for overcoming them. Finally, the post will summarize the main points and encourage readers to embrace dyslexia as a gift. By following this outline, the blog post will attract readers and optimize for search engines with a catchy title and valuable content.',
  url: '/Why-do-people-say-dyslexia-is-a-gift'
},{
  id: 14,
  title: 'Understanding the Rarity of Dyslexia in the UK',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a neurodevelopmental disorder that affects reading and writing skills, and it is estimated that 10% of the population in the UK has dyslexia. Despite this relatively high prevalence rate, dyslexia is often misunderstood and its impact on individuals and society is often overlooked. Understanding the rarity of dyslexia in the UK is therefore crucial in order to raise awareness, promote early detection and intervention, and support dyslexic individuals to reach their full potential. In this article, we will provide an overview of dyslexia in the UK, including prevalence rates, causes, and support options. We will also share inspiring success stories of dyslexic individuals who have overcome their challenges and achieved great things. By the end of this article, we hope to shed light on the reality of dyslexia in the UK and inspire readers to take action to support and empower dyslexic individuals.',
  url: '/Understanding-the-Rarity-of-Dyslexia-in-the-UK'
},
{
  id: 15,
  title: '5 Essential Steps for Effective Idea Generation',
  datePublished: '17/03/2023',
  summary: 'Idea generation is a critical aspect of innovation and problem-solving across various fields and industries. Whether you are an entrepreneur looking to develop a new product, a marketer devising a new campaign, or a scientist exploring new avenues of research, generating and implementing ideas is a fundamental process that drives progress and success. However, the process of idea generation can often feel overwhelming or uncertain, especially when faced with complex problems or limited resources. To ensure effective idea generation, it is crucial to follow a structured approach that involves a series of steps that guide the process from identifying the problem or opportunity to refining and implementing the chosen idea. In this article, we will discuss the five essential steps for effective idea generation, providing tips and strategies to help you navigate each stage of the process and increase your chances of success.',
  url: '/5-Essential-Steps-for-Effective-Idea-Generation'
},
{
  id: 16,
  title: 'Effective Communication: How to Discuss Your Ideas with People',
  datePublished: '17/03/2023',
  summary: 'This blog post is all about effective communication when discussing ideas with others. The author provides several tips to prepare for the discussion, establish common ground, use active listening skills, express ideas clearly and concisely, find solutions, and reach a conclusion. The post emphasizes the importance of clear communication and collaboration, and encourages readers to put these tips into practice in their own discussions. SEO keywords include communication, discuss ideas, effective communication, active listening, collaboration, common ground, expressing ideas, solutions, and conclusion.',
  url: '/Effective-Communication-How-to-Discuss-Your-Ideas-with-People'
},
{
  id: 17,
  title: 'Mastering the Art of Communicating Complex Ideas: A Guide',
  datePublished: '17/03/2023',
  summary: 'Communicating complex ideas can be challenging, especially if the audience lacks the required knowledge and expertise to understand the content. However, mastering the art of communicating complex ideas is crucial for individuals in various fields, including academia, business, and research. This blog will provide a comprehensive guide on how to effectively communicate complex ideas. The guide will cover various aspects of effective communication, including understanding your audience, simplifying complex ideas, structuring your message, using language effectively, non-verbal communication, and practicing and receiving feedback. By the end of the blog, readers will be equipped with the necessary tools and techniques to communicate complex ideas with ease and confidence.',
  url: '/Mastering-the-Art-of-Communicating-Complex-Ideas'
},{
  id: 19,
  title: 'The Importance of Communication in Interviews: Why It Matters for Job Seekers',
  datePublished: '4/04/2023',
  summary: 'Communication skills are critical for job seekers, especially during interviews. In this blog post, we will explore the importance of effective communication in interviews, its impact on the hiring process, and provide tips for job seekers to improve their communication skills and ace their interviews.',
  url: '/The-Importance-of-Communication-in-Interviews'
},
{
  id: 20,
  title: 'Mastering Classroom Management: Understanding the 3 Cs of Communication',
  datePublished: '6/04/2023',
  summary: 'Effective communication is an essential aspect of classroom management. To achieve success, educators must understand and implement the three Cs of communication: clarity, consistency, and compassion. This blog post delves into the importance of each C, offering strategies to improve communication within the classroom. Additionally, we explore how the 3 Cs work together to create a positive learning environment. Finally, we discuss potential challenges that may arise when implementing these strategies and offer solutions to overcome them. By the end of this article, readers will have a deeper understanding of the 3 Cs and be able to apply them to their own classroom management practices.',
  url: '/Mastering-Classroom-Management-Understanding-the-Cs-of-Communication'
},{
  id: 21,
  title: 'The Importance of Effective Communication: When and Where It Is Essential',
  datePublished: '17/03/2023',
  summary: 'Effective communication is a critical aspect of daily life, both in personal and professional contexts. From sharing information to resolving conflicts, communication helps to build relationships and ensure that everyone is on the same page. However, not all situations require the same level or style of communication. In this blog, we will explore when and where effective communication is essential, from the workplace to personal relationships and beyond.',
  url: '/The-Importance-of-Effective-Communication'
},{
  id: 22,
  title: 'The Top Reasons Why Communication Breakdowns Occur',
  datePublished: '08/04/2023',
  summary: 'Communication breakdowns can occur in any type of relationship, whether personal or professional. The ability to communicate effectively is crucial in order to convey thoughts, feelings, and information accurately. In this article, we will explore the top reasons why communication breakdowns occur. These include a lack of clarity, emotional barriers, physical barriers, cultural differences, and a lack of active listening. By understanding the reasons for communication breakdowns, individuals can work to improve their communication skills and avoid misunderstandings.',
  url: '/The-Top-Reasons-Why-Communication-Breakdowns-Occur'
},{
  id: 23,
  title: 'The Ultimate Guide to Effective Communication While Working Remotely',
  datePublished: '11/04/2023',
  summary: 'Effective communication is crucial for the success of remote teams. However, remote work comes with its own set of communication challenges that can hinder productivity and teamwork. This blog post provides insights into how to overcome these challenges and offers practical tips and best practices for communicating effectively while working remotely. By implementing the tips and best practices discussed, remote teams can establish a strong communication culture that fosters productivity, trust, and teamwork.',
  url: '/The-Ultimate-Guide-to-Effective-Communication-While-Working-Remotely'
},{
  id: 24,
  title: 'Navigating Communication Breakdown: Strategies for Recovery and Resolution',
  datePublished: '17/04/2023',
  summary: 'Communication breakdowns can happen to anyone, causing misunderstandings, conflict, and damage to relationships. However, it is possible to recover from these breakdowns and repair the damage done. In this blog, we will explore effective strategies for recovering from communication breakdown, including techniques for resolving conflicts, rebuilding trust, and improving communication skills.',
  url: '/Navigating-Communication-Breakdown-Strategies-for-Recovery-and-Resolution'
},{
  id: 25,
  title: 'Is dyslexia a condition developed or born with?',
  datePublished: '20/04/2023',
  summary: 'Dyslexia is a condition that affects a persons ability to read, write, and spell. There is an ongoing debate about whether dyslexia is developed or born with. Some research suggests that dyslexia has genetic origins, while other studies point to environmental factors such as early childhood experiences, education, and socio-economic status. In this blog post, we will explore the evidence for both genetic and environmental factors in dyslexia development, and the implications of this knowledge for diagnosis and treatment.',
  url: '/Is-Dyslexia-A-Condition-Developed-Or-Born-With'
},{
  id: 26,
  title: 'Busting the Myths: Common Misconceptions About Dyslexia',
  datePublished: '22/04/2023',
  summary: 'Dyslexia is a learning disorder that affects millions of people worldwide, but there are many misconceptions surrounding this condition. In this blog, we will debunk five common misconceptions about dyslexia. First, we will address the belief that dyslexia is a visual problem, and provide evidence to support the fact that it is actually a language-based disorder. We will also dispel the myth that dyslexia is caused by low intelligence and explain why this belief is harmful. Next, we will discuss the misconception that dyslexia only affects reading and writing, when in reality, it can impact other areas of learning as well. We will also address the idea that dyslexia can be cured, and explain why there is no cure for this condition, but there are effective interventions available. Finally, we will debunk the belief that dyslexia is rare, and provide information on the prevalence of this disorder. It is important to understand dyslexia and recognize the strengths and challenges of individuals with this condition. By busting these myths, we hope to promote greater understanding and support for those with dyslexia.',
  url: '/Common-Misconceptions-About-Dyslexia'
},{
  id: 27,
  title: 'Mind Mapping: A Powerful Tool for Effective Communication',
  datePublished: '22/04/2023',
  summary: 'Effective communication is essential in all aspects of our lives. Whether we are trying to convey our ideas to our colleagues, presenting a proposal to a client, or discussing a project with a team, communication is the key to success. In this blog post, we will explore the benefits of mind mapping as a powerful tool for effective communication. We will discuss how mind mapping can help you to organise your thoughts, improve your communication skills, and enhance your creativity.',
  url: '/Mind-Mapping-A-Powerful-Tool-for-Effective-Communication'
},
]


const BlogOne = () => {
  
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openTwo, setOpenTwo] = useState(false);
  const emailRef2 = useRef();
  const passwordRef2 = useRef();
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  const { currentUser, signup, login } = useAuth();
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [stripeId, setStripeId] = useState("");

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});


  useEffect(() => {
    if (currentUser && currentUser.uid) { // add a null check before accessing uid
      const unsubscribe = firestore
        .collection("customers")
        .doc(currentUser.uid)
        .onSnapshot((doc) => {
          const data = doc.data();
          setStripeId(data?.stripeId || ""); // set stripeId state
        });
  
      return unsubscribe; // cleanup the listener
    }
  }, [currentUser]);

  
    const handleOpen = () => {
      if(!currentUser){
        setOpen(true);
      }else{
        history.push("/workspace")
      }
    };

    const handleOpenTwo = () => {
      if(!currentUser){
        setOpenTwo(true);
      }else{
        
        const handleCustomerPortalClick = async () => {
          setIsLoading(true);
        
          try {
            const response = await fetch(`${process.env.REACT_APP_PORTAL}/create-portal-link`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                returnUrl: window.location.origin,
                locale: 'auto',
                userId: `${stripeId}`
              }),
            });
        
            const { url } = await response.json();
            window.location.assign(url);
          } catch (error) {
            console.error(error);
          } finally {
            setIsLoading(false);
          }
        };

        handleCustomerPortalClick();

      }
      
    };


    const handleOpenThree = () => {
      if(!currentUser){
        setOpenTwo(true);
      }else{
        history.push("/workspace")
      }
    };




    const SignInButtonModalTwo = () => {

      const handleClose = () => {
        setOpenTwo(false);
      };
    
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          setError("");
          setLoading(true);
          await login(emailRef2.current.value, passwordRef2.current.value);
          history.push("/workspace")
          handleClose();
        } catch {
          setError("Incorrect email or password.");
        }
    
        setLoading(false);
      };
      
      
      return (
        <div>
        <Modal
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', outline:'none' }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openTwo}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500
          }}
        >
          <Fade in={openTwo}>
            <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0px 3px 20px rgba(0,0,0,0.1)', padding: '30px', maxWidth: '400px', width: '100%', outline:'none' }}>
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
  <IconButton onClick={handleClose}>
    <CloseIcon />
  </IconButton>
</div>
                <center>
                  <h2 style={{ fontFamily: "Inter", fontSize: "30px", fontWeight: "bold" }}>Sign In</h2>
                  <h5 style={{ color: "red" }}>{error}</h5>
                  <form style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onSubmit={handleSubmit}>
                    <TextField
                      id="email"
                      label="Email"
                      inputRef={emailRef2}
                      required
                      sx={{
                        "& fieldset": {
                          border: "none",
                        },
                      }}
                      InputProps={{
                        style: {
                          width: "100%",
                          fontFamily: "'inter",
                          fontStyle: "normal",
                          fontWeight: 700,
                          fontSize: "20px",
                          color: `grey`,
                          margin: "20px",
                          textAlign: "center",
                          "&::placeholder": {
                            textAlign: "center",
                          },
                        },
                      }}
                    />
                    <TextField
                      inputRef={passwordRef2}
                      required
                      id="Password"
                      label="Password"
                      type="password"
                      sx={{
                        "& fieldset": {
                          border: "none",
                        },
                      }}
                      InputProps={{
                        style: {
                          width: "100%",
                          fontFamily: "'inter",
                          fontStyle: "normal",
                          fontWeight: 700,
                          fontSize: "20px",
                          color: `grey`,
                          margin: "20px",
                          textAlign: "center",
                          "&::placeholder": {
                            textAlign: "center",
                          },
                        },
                      }}
                    />
                    <Button
                      style={{ backgroundColor: "#7E3AF2", color: "white", fontFamily: "Inter", marginBottom: "10px" }}
                      disabled={loading}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </form>
                  <div style={{ paddingTop: "60px" }}>
                    <Password />
                  </div>
                  <h4 style={{ color: "#7E3AF2", fontFamily: "Inter", margin: "30px", cursor: "pointer" }} onClick={() => { handleClose(); handleOpen(); }}>
                    Need an account?
                  </h4>
                </center>
              </div>
            </Fade>
          </Modal>
        </div>
      );
      
        
      
      };
  
    

  const SignInButtonModal = () => {

  const handleClose = () => {
    setOpen(false);
  };


    async function handleSubmit(e) {
      e.preventDefault()
  
      if (passwordRef.current.value !== passwordConfirmRef.current.value) {

        return setError("Passwords do not match")
        
      } else {

        try {
          setError("")
          setLoading(true)
          await signup(emailRef.current.value, passwordRef.current.value);
          history.push("/workspace")
          handleClose();
        } catch {
          setError("Failed to create an account")
        }

      }
  
      setLoading(false)
    };
  
  
    return (
      <div>
        <Modal
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500
          }}
        >
          <Fade in={open}>
            <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0px 3px 20px rgba(0,0,0,0.1)', padding: '30px', maxWidth: '400px', width: '100%' }}>
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
  <IconButton onClick={handleClose}>
    <CloseIcon />
  </IconButton>
</div>
              <center>
                <h2 style={{ fontFamily: 'Inter', fontSize: "30px", fontWeight: 'bold' }}>Sign Up</h2>
                {error}
                <form onSubmit={handleSubmit} style={{ textAlign: "center" }}>
                  <TextField
                    inputRef={emailRef}
                    required
                    label="Email"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <TextField
                    inputRef={passwordRef}
                    required
                    label="Password"
                    type="password"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <TextField
                    inputRef={passwordConfirmRef}
                    required
                    label="Password Confirmation"
                    type="password"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <Button style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', margin: '30px' }} type="submit">
                    Submit
                  </Button>
                </form>
                <p>Please note, by signing up you are agreeing to our terms and condiction.</p>
                <h4 style={{ color: '#7E3AF2', fontFamily: 'Inter', margin: '30px', cursor: 'pointer' }} onClick={() => { handleClose(); handleOpenTwo(); }}>
                  Have an account?
                </h4>
              </center>
            </div>
          </Fade>
        </Modal>
      </div>
    ); };

  
    return (
        <>
          <div>
          <AppBar position="static" style={{ backgroundColor: 'white', boxShadow: "none" }}>
      <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Link to='/'><img src={logo} alt="logo" style={{ width: '150px' }} /></Link>
        <div style={{ display: 'flex', gap: '20px' }}>
        <Link style={{textDecoration: 'none'}} to="/">
  <Button style={{ backgroundColor: 'transparent', textDecoration: 'none', color: 'black', border: 'none', outline: 'none', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
    Home
  </Button>
</Link>
          <Button onClick={() => handleOpenThree()} style={{ backgroundColor: 'transparent', textDecoration: 'none', color: 'black', border: 'none', outline: 'none', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
      Sign In
    </Button>
          <Button onClick={() => handleOpen()} style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
            Sign Up
          </Button>
        </div>
      </Toolbar>
    </AppBar>
            {SignInButtonModal()}
            {SignInButtonModalTwo()}
          </div>
          <center style={{backgroundColor: '#F9FAFB', padding:'5%'}} data-aos="fade-up" data-aos-duration="3000">
      <div >
        <h1>Dyslexia Decoded</h1>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
        <div style={{textAlign:'left'}}>
            <h1  style={{fontFamily: 'Inter'}}>Does dyslexia affect verbal comprehension?</h1>
            <p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
            Dyslexia is a common learning disorder that affects the ability to read, write, and spell. People with dyslexia may struggle with phonemic awareness, decoding, and word recognition, which can impact their academic performance and everyday life. However, dyslexia is not just limited to reading and writing; it can also affect other areas of learning, such as verbal comprehension. Verbal comprehension is the ability to understand and process spoken language, which is crucial for communication, learning, and social interactions. In this blog post, we will explore the relationship between dyslexia and verbal comprehension. We will examine the challenges that people with dyslexia face in understanding spoken language and discuss strategies to improve their verbal comprehension skills. Understanding this relationship can help educators, parents, and individuals with dyslexia to better navigate and overcome the challenges associated with dyslexia.
            </p>
            <br/><br/>
<center>
<img src={talk} alt="someone telling someone to speak up" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
            <h2>Understanding Dyslexia</h2>
            <p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
            Dyslexia is a specific learning disorder that affects the ability to read, write, and spell. It is estimated to affect around 10% of the population, with varying degrees of severity. Dyslexia is often diagnosed in childhood, but it can also go undiagnosed until adulthood.

<br/><br/>People with dyslexia may experience difficulty with phonemic awareness, decoding, and word recognition. Phonemic awareness is the ability to identify and manipulate individual sounds in words, while decoding refers to the ability to translate written words into spoken language. Word recognition is the ability to quickly and accurately identify words by sight.

<br/><br/>The exact causes of dyslexia are not fully understood, but research suggests that it is a complex interaction of genetic, neurological, and environmental factors. Dyslexia can run in families, and studies have identified differences in brain structure and function in people with dyslexia compared to those without the disorder.

<br/><br/>Despite the challenges associated with dyslexia, many individuals with dyslexia possess strengths in other areas, such as problem-solving, creativity, and critical thinking. With proper support and intervention, people with dyslexia can learn to read and write and achieve their full potential.
            </p>
            <br/><br/>
<center>
<img src={dis} alt="spongebob spelling dyslexia" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
            <h2>Verbal Comprehension</h2>
            <p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
            Verbal comprehension is the ability to understand and process spoken language. It is an essential skill for communication, learning, and social interaction. Verbal comprehension involves a range of cognitive processes, including attention, memory, and language comprehension.

            <br/><br/>In order to understand spoken language, individuals need to be able to pay attention to the words being spoken and remember them long enough to comprehend their meaning. They also need to be able to decode and interpret the language being used, including recognizing the sounds and meaning of words, as well as understanding grammar and syntax.

            <br/><br/>Factors that can affect verbal comprehension include language development, attention, working memory, and processing speed. For individuals with dyslexia, these factors can be particularly challenging, as the disorder can affect the processing of language and information.

            <br/><br/>Difficulties with verbal comprehension can have significant impacts on academic and social outcomes for individuals with dyslexia. They may struggle with following instructions, understanding lectures, or engaging in conversations. They may also have difficulty with written language, as verbal comprehension is often essential for understanding written text.

            <br/><br/>In the next section, we will explore the relationship between dyslexia and verbal comprehension and the specific difficulties that people with dyslexia may face in this area.
            </p>
            <br/><br/>
<center>
<img src={fast} alt="someone talking fast" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
            <h2>Dyslexia and Verbal Comprehension</h2>
            <p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
            Research suggests that dyslexia can affect verbal comprehension, as the disorder can interfere with the processing of language and information. Individuals with dyslexia may struggle with following spoken instructions, understanding lectures or conversations, and processing information quickly.

            <br/><br/>Difficulties with phonemic awareness, decoding, and word recognition, which are commonly associated with dyslexia, can also impact verbal comprehension. For example, individuals with dyslexia may struggle to recognize and interpret the sounds and meanings of words, which can make it difficult to understand spoken language.

            <br/><br/>Additionally, dyslexia can affect other cognitive processes that are important for verbal comprehension, such as attention, working memory, and processing speed. For example, individuals with dyslexia may have difficulty paying attention to spoken language or remembering the words long enough to comprehend their meaning.

            <br/><br/>Despite these challenges, individuals with dyslexia often possess strengths in other areas, such as problem-solving, creativity, and critical thinking. With proper support and intervention, individuals with dyslexia can learn to overcome the challenges associated with verbal comprehension and achieve their full potential.

            <br/><br/>In the next section, we will discuss strategies for improving verbal comprehension in individuals with dyslexia, including educational strategies and technological tools.
            </p>
            <br/><br/>
<center>
<img src={thinking} alt="someone thinking hard" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
            <h2>Strategies for Improving Verbal Comprehension in People with Dyslexia</h2>
            <p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
            There are several strategies and interventions that can help individuals with dyslexia improve their verbal comprehension skills. These strategies can be tailored to the specific needs and strengths of each individual, and can include educational strategies, technological tools, and other interventions.

            <br/><br/>Educational Strategies
            <br/>Educational strategies can include specialized reading and language programs that focus on improving phonemic awareness, decoding, and word recognition. These programs can help individuals with dyslexia to better recognize and interpret the sounds and meanings of words, which can improve their verbal comprehension skills.

            <br/><br/>In addition, accommodations such as extended time on tests, audio recordings of lectures, and note-taking assistance can also help individuals with dyslexia to better understand and process spoken language.

            <br/><br/>Technological Tools
            <br/>Technological tools can also be helpful in improving verbal comprehension in individuals with dyslexia. For example, text-to-speech software can convert written text into spoken language, which can make it easier for individuals with dyslexia to understand and process information.

            <br/><br/>Similarly, speech-to-text software can convert spoken language into written text, which can help individuals with dyslexia to better express their thoughts and ideas.

            <br/><br/>Other Interventions
            <br/>Other interventions that may be helpful for improving verbal comprehension in individuals with dyslexia include cognitive-behavioral therapy, which can help individuals to develop strategies for managing attention and improving memory, and occupational therapy, which can help individuals to develop fine motor skills and other abilities that can support language development.

            <br/><br/>Dyslexia can impact verbal comprehension skills, but with proper support and interventions, individuals with dyslexia can learn to overcome these challenges and achieve their full potential. By utilizing educational strategies, technological tools, and other interventions, individuals with dyslexia can improve their verbal comprehension skills and better navigate the challenges associated with the disorder.
            </p>
            <br/><br/>
<center>
<img src={smart} alt="joey from friends saying you're smart" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
            <h2>Overview</h2>
            <p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
            In conclusion, dyslexia can have a significant impact on an individual's verbal comprehension skills, as the disorder can interfere with the processing of language and information. Difficulties with phonemic awareness, decoding, and word recognition, as well as attention, working memory, and processing speed, can all contribute to challenges in understanding spoken language.

            <br/><br/>However, with proper support and intervention, individuals with dyslexia can improve their verbal comprehension skills and achieve success in academic and social settings. Educational strategies, such as specialized reading and language programs, as well as accommodations like extended time on tests and audio recordings of lectures, can be helpful in improving verbal comprehension.

            <br/><br/>Technological tools like text-to-speech and speech-to-text software can also be beneficial for individuals with dyslexia, as they can help to bridge the gap between spoken and written language. Additionally, other interventions like cognitive-behavioral therapy and occupational therapy can help individuals with dyslexia to develop strategies for managing attention and improving memory, as well as fine motor skills that can support language development.

            <br/><br/>Overall, dyslexia is a complex disorder that can present unique challenges for individuals with the condition. However, with the right support, people with dyslexia can learn to overcome these challenges and reach their full potential. By understanding the relationship between dyslexia and verbal comprehension and utilizing appropriate interventions, we can help individuals with dyslexia to achieve success in academic, social, and professional settings.
            </p>
            <br/><br/>
<center>
<img src={peace} alt="someone throwing up peace signs with their hands" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
          </div>
        </Grid>
        <Grid item xs={12} md={4}>
        <div style={{ position: 'sticky', top: 23, }}>
      <Card style={{ margin: '30px', textAlign:'left' }}>
        <CardContent>
          <h2>Recent Posts</h2>
          {posts.reverse().slice(0, 5).map(post => (
            <div key={post.id}>
              <Link style={{color:'black', textDecoration: 'none'}} to={`${post.url}`}>
                <h4>{post.title}</h4>
              </Link>
              <Divider />
            </div>
          ))}
          <Link to="/blog"><button style={{ fontFamily: 'Inter', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', padding: '32px', borderRadius: '8px', border: 'none', cursor: 'pointer', width:'100%' }}>View other articles</button></Link>
        </CardContent>
      </Card>
    </div>
    
        </Grid>
      </Grid>
    </center>
          {/* CTA*/}
          <div style={{ marginTop: '100px', marginBottom: '100px', backgroundColor: 'white' }} data-aos="fade-up" data-aos-duration="3000">
            <div style={{ display: "flex", flexDirection: "row", textAlign: 'center' }}>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignContent: 'left' }}>
              <h3 style={{ fontFamily: 'Inter', fontSize: "35px", fontWeight: 'bold' }}>Struggling to communicate your thoughts?</h3>
                <h5 style={{ fontFamily: 'Inter', color: '#6B7280' }}>Use our AI assisted thought management framework to help you communicate your ideas or feelings.</h5>
                <button onClick={() => handleOpen()} style={{ fontFamily: 'Inter', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', padding: '16px 32px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>Start a board</button>
                <video style={{ borderRadius: '10px', maxWidth: '100%', padding:'3%' }} width="640" height="360" controls>
          <source src={Crowd} type="video/mp4" />
        </video>
              </div>
            </div>
          </div>
          <div>
          <center>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ flex: 1 }}>
                <img src={logo} alt="logo" style={{ maxWidth: '10%', minWidth: '15%', padding: '10px' }} />
              </div>
            </div>
            <h4 ><Link style={{textDecoration: 'none'}} to="/">Homepage</Link></h4>
              <p style={{ fontSize: '10px' }}>Copyright ® 2023 All rights Reserved.
              </p>
            </center>
          </div>
        </>
      );
  
}

export default BlogOne;
